export class Exception extends Error {
   public name: string = "Exception";
   static create(msg: string) {
      return new Exception(msg);
   }
}
